/* Bundle Builder — Složi svoju kutiju
 * Controller for multi-step bundle building UX.
 * Reads config from window.bundleBuilderConfig (injected via Liquid).
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'bundleBuilder.state';
  const STORAGE_TTL_MS = 24 * 60 * 60 * 1000; // 24h

  const state = {
    currentStep: 0,
    selectedProducts: [], // [{variantId, title, price, imageUrl}]
    selectedBox: null,    // {variantId, title, price, imageUrl} or null
    confettiShown: false,
  };

  // ---- Init ----

  function init() {
    const config = window.bundleBuilderConfig;
    if (!config) {
      console.warn('Bundle Builder: no config found');
      return;
    }

    restoreState();
    bindEvents();
    render();
  }

  // ---- State persistence ----

  function saveState() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        data: state,
      }));
    } catch(e) { /* sessionStorage full or unavailable */ }
  }

  function restoreState() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.timestamp > STORAGE_TTL_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      Object.assign(state, parsed.data);
    } catch(e) { /* corrupt state, ignore */ }
  }

  function resetState() {
    state.currentStep = 0;
    state.selectedProducts = [];
    state.selectedBox = null;
    try { sessionStorage.removeItem(STORAGE_KEY); } catch(e) {}
  }

  // ---- Navigation ----

  function goToStep(n) {
    const wasOnStep = state.currentStep;
    state.currentStep = n;
    saveState();
    render();
    window.scrollTo({ top: document.querySelector('.bb-container').offsetTop - 20, behavior: 'smooth' });

    // Fire confetti once on first arrival to step 4 (review)
    if (n === 3 && wasOnStep !== 3 && !state.confettiShown && typeof window.confetti === 'function') {
      state.confettiShown = true;
      window.confetti({
        particleCount: 90,
        spread: 75,
        origin: { y: 0.4 },
        colors: ['#05bab5', '#048d89', '#bce8e3', '#ffffff', '#f8e7dd'],
      });
    }
  }

  function canAdvanceFromStep(n) {
    if (n === 1) return state.selectedProducts.length >= 2;
    return true;
  }

  // ---- Product selection ----

  function toggleProduct(variantId, productData) {
    const idx = state.selectedProducts.findIndex(p => p.variantId === variantId);
    if (idx >= 0) {
      state.selectedProducts.splice(idx, 1);
    } else {
      if (state.selectedProducts.length >= 4) return; // max 4
      state.selectedProducts.push(productData);
    }
    saveState();
    render();
  }

  function toggleBox(variantId, boxData) {
    if (state.selectedBox && state.selectedBox.variantId === variantId) {
      state.selectedBox = null;
    } else if (variantId === null) {
      state.selectedBox = null;
    } else {
      state.selectedBox = boxData;
    }
    saveState();
    render();
  }

  // ---- Pricing calc ----

  function calcDiscount(productCount) {
    if (productCount >= 4) return 0.30;
    if (productCount >= 3) return 0.25;
    if (productCount >= 2) return 0.20;
    return 0;
  }

  function calcTotals() {
    const subtotalProducts = state.selectedProducts.reduce((sum, p) => sum + parseFloat(p.price), 0);
    const boxPrice = state.selectedBox ? parseFloat(state.selectedBox.price) : 0;
    const discountRate = calcDiscount(state.selectedProducts.length);
    const discountAmount = subtotalProducts * discountRate;
    const total = subtotalProducts + boxPrice - discountAmount;
    return {
      subtotalProducts,
      boxPrice,
      discountRate,
      discountAmount,
      total,
    };
  }

  // ---- Cart integration ----

  async function addToCart() {
    const items = state.selectedProducts.map(p => ({
      id: p.variantId,
      quantity: 1,
      properties: { _Bundle: 'Složi svoju kutiju' },
    }));

    if (state.selectedBox) {
      items.push({
        id: state.selectedBox.variantId,
        quantity: 1,
        properties: { _Bundle: 'Složi svoju kutiju' },
      });
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('Cart add failed');
      resetState();
      window.location.href = '/cart';
    } catch(e) {
      alert('Nešto je pošlo po krivu pri dodavanju u košaricu. Pokušaj ponovno.');
      console.error(e);
    }
  }

  // ---- Rendering ----

  function render() {
    renderProgress();
    renderStepVisibility();
    renderProductGrid();
    renderRunningTotal();
    renderBoxGrid();
    renderReview();
    renderNavButtons();
  }

  function renderProgress() {
    const bars = document.querySelectorAll('.bb-progress__bar');
    bars.forEach((bar, i) => {
      bar.classList.toggle('is-done', i < state.currentStep);
      bar.classList.toggle('is-active', i === state.currentStep);
    });
  }

  function renderStepVisibility() {
    document.querySelectorAll('.bb-step').forEach((step, i) => {
      step.classList.toggle('is-active', i === state.currentStep);
    });
    document.querySelectorAll('.bb-section').forEach(section => {
      const stepIndex = parseInt(section.dataset.stepIndex, 10);
      const isActive = stepIndex === state.currentStep;
      section.classList.toggle('is-active-section', isActive);
    });
  }

  function renderProductGrid() {
    const grid = document.querySelector('.bb-products__grid');
    if (!grid) return;
    const products = grid.querySelectorAll('.bb-product');
    const maxReached = state.selectedProducts.length >= 4;

    products.forEach(card => {
      const variantId = card.dataset.variantId;
      const isSelected = state.selectedProducts.some(p => p.variantId === variantId);
      card.classList.toggle('is-selected', isSelected);
      card.classList.toggle('is-disabled', maxReached && !isSelected);
    });
  }

  function renderRunningTotal() {
    const totalEl = document.querySelector('.bb-running-total');
    if (!totalEl) return;

    const t = calcTotals();
    const count = state.selectedProducts.length;

    if (count === 0) {
      totalEl.innerHTML = '<div class="bb-running-total__line">Klikni proizvode da ih dodaš u kutiju (min. 2)</div>';
      return;
    }

    let nextTierMsg;
    if (count === 1) nextTierMsg = '💡 Dodaj još 1 proizvod za 20% popusta';
    else if (count === 2) nextTierMsg = '💡 Dodaj još 1 proizvod za 25% popusta';
    else if (count === 3) nextTierMsg = '💡 Dodaj još 1 proizvod za 30% popusta';
    else nextTierMsg = '🎉 Maksimalan popust ostvaren!';

    totalEl.innerHTML = `
      <div class="bb-running-total__line"><span>Proizvodi (${count})</span><span>${formatPrice(t.subtotalProducts)}</span></div>
      ${t.discountRate > 0 ? `<div class="bb-running-total__line bb-running-total__discount"><span>Popust −${Math.round(t.discountRate*100)}%</span><span>−${formatPrice(t.discountAmount)}</span></div>` : ''}
      <div class="bb-running-total__final"><span>Privremeno ukupno</span><span>${formatPrice(t.subtotalProducts - t.discountAmount)}</span></div>
      ${count < 4 ? `<div class="bb-running-total__nudge">${nextTierMsg}</div>` : ''}
    `;
  }

  function renderBoxGrid() {
    const boxGrid = document.querySelector('.bb-box__options');
    if (!boxGrid) return;
    boxGrid.querySelectorAll('.bb-box-option').forEach(opt => {
      const isSelected = state.selectedBox && state.selectedBox.variantId === opt.dataset.variantId;
      opt.classList.toggle('is-selected', isSelected);
    });
  }

  function renderReview() {
    const reviewEl = document.querySelector('.bb-review__items');
    if (!reviewEl || state.currentStep !== 3) return;

    const t = calcTotals();
    const thumb = (url) => url
      ? `<img src="${url}" alt="" class="bb-review__thumb" loading="lazy">`
      : `<div class="bb-review__thumb"></div>`;

    let html = '';
    state.selectedProducts.forEach(p => {
      html += `<div class="bb-review__row">${thumb(p.imageUrl)}<span class="bb-review__name">${p.title}</span><span class="bb-review__price">${formatPrice(parseFloat(p.price))}</span></div>`;
    });
    if (state.selectedBox) {
      html += `<div class="bb-review__row">${thumb(state.selectedBox.imageUrl)}<span class="bb-review__name">${state.selectedBox.title}</span><span class="bb-review__price">${formatPrice(parseFloat(state.selectedBox.price))}</span></div>`;
    }
    if (t.discountRate > 0) {
      html += `<div class="bb-review__line bb-review__discount-line"><span>Popust −${Math.round(t.discountRate*100)}%</span><span>−${formatPrice(t.discountAmount)}</span></div>`;
    }
    html += `<div class="bb-review__line bb-review__total-line"><span>Ukupno</span><span>${formatPrice(t.total)}</span></div>`;
    reviewEl.innerHTML = html;
  }

  function renderNavButtons() {
    const advanceBtn = document.querySelector(`.bb-step.is-active .bb-btn--advance`);
    if (advanceBtn) {
      advanceBtn.disabled = !canAdvanceFromStep(state.currentStep);
    }
  }

  function formatPrice(amount) {
    return amount.toFixed(2).replace('.', ',') + ' €';
  }

  // ---- Event binding ----

  function bindEvents() {
    document.addEventListener('click', e => {
      // Product card
      const productCard = e.target.closest('.bb-product');
      if (productCard && !productCard.classList.contains('is-disabled')) {
        toggleProduct(productCard.dataset.variantId, {
          variantId: productCard.dataset.variantId,
          title: productCard.dataset.title,
          price: productCard.dataset.price,
          imageUrl: productCard.dataset.imageUrl,
        });
        return;
      }

      // Box option
      const boxOption = e.target.closest('.bb-box-option');
      if (boxOption) {
        toggleBox(boxOption.dataset.variantId, {
          variantId: boxOption.dataset.variantId,
          title: boxOption.dataset.title,
          price: boxOption.dataset.price,
          imageUrl: boxOption.dataset.imageUrl,
        });
        return;
      }

      // Skip box button
      if (e.target.matches('.bb-box-skip-btn')) {
        state.selectedBox = null;
        saveState();
        goToStep(state.currentStep + 1);
        return;
      }

      // Navigation buttons
      if (e.target.matches('.bb-btn--advance')) {
        goToStep(state.currentStep + 1);
        return;
      }
      if (e.target.matches('.bb-btn--back')) {
        goToStep(state.currentStep - 1);
        return;
      }
      if (e.target.matches('.bb-btn--add-to-cart')) {
        addToCart();
        return;
      }
    });
  }

  // ---- Boot ----

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
